export default "__VITE_ASSET__wmh8ard0__"